import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController, DateTime} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InformesProvider } from '../../providers/informes/informes'
import * as papa from 'papaparse'
import { CajaProvider } from '../../providers/caja/caja'
import { UtilsProvider } from '../../providers/utils/utils'
import { DianProvider } from '../../providers/dian/dian';

@IonicPage()
@Component({
  selector: 'informe-reimprimir-recibo-caja',
  templateUrl: 'informe-reimprimir-recibo-caja.html',
  providers: [ AuthService ,InAppBrowser,CajaProvider,DianProvider]
})
export class InformeReimprimirReciboCajaPage {
  datosPagina:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  fechaDesde:Date
  fechaHasta:Date
  imprimirNombreInforme:string=''
  listaVentasReimprimo = []
  parsedData:any
  parsedDataReal:any
  parseDataHeader:any
  @Input() showHeader: boolean = true;
  hacerSeguimientoLuegoDeVenta:boolean = false
  listaSeguimientoReserva = []
  valorfecha= []
  @Output() cambiarFecha = new EventEmitter<string>();
  fechaInicio = new Date(1900, 0, 1);
  fechaInicioHora: any;
  fechaFinHora: any;
  fechaFin = new Date(1900, 0, 1);
  selectedHour: string = "";
  isTime: boolean = false;
  fechaInicialSelect: boolean = true;
  fechaInicialSelectColor: string = '#083472';
  fechaFinalSelect: boolean = false;
  @Output() datosServiceCalendar = new EventEmitter<string>();
  valorfechaInicial:string = ''
  valorFechaFinal:string = ''
  isFocusedFechaInicial: boolean = false;
  isFocusedFechaFinal: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public servicioCompania:CompaniasProvider,private iab: InAppBrowser,
             public servicioCaja: CajaProvider,
             public utils: UtilsProvider,
             public servicio:InformesProvider,
             public dian: DianProvider) {
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })
                this.storages.set('reimprimirReciboCaja','')
               }else{

                 this.navCtrl.setRoot('PrincipalPage');
               }
  }


  async ionViewDidLoad() {

    let datosGenerales = localStorage.getItem('datosGenerales')
    let datosGeneralesJSON = JSON.parse(datosGenerales)
    if(datosGeneralesJSON && datosGeneralesJSON["hacerSeguimientoLuegoDeVenta"]) {
      this.hacerSeguimientoLuegoDeVenta = datosGeneralesJSON["hacerSeguimientoLuegoDeVenta"].seleccion === 'N' ? false : true
    }

  }
  public event = {
    default: "ddd MMM DD YYYY HH:mm:ss"
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarRecibosCajaReImprime(){
    let fechaDesde = this.fechaDesde
    let fechaHasta = this.fechaHasta
    this.storages.get('companiasId').then((val) => {

      this.servicio.buscarListadoRecibosCajaReImprime(val,fechaDesde,fechaHasta)
          .subscribe((data)=>{
           let valor = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])

           if (Array.isArray(valor) && Array.isArray(valor[0])) {
            this.listaVentasReimprimo = valor[0].map(item => {
              item.valorVenta = this.cleanNumber(item.valorVenta);
              return item;
            });
          } else if (Array.isArray(valor)) {
            this.listaVentasReimprimo = valor.map(item => {
              item.valorVenta = this.cleanNumber(item.valorVenta);
              return item;
            });
          } else {
            this.listaVentasReimprimo = [];
          }

          // this.listaVentasReimprimo = this.listaVentasReimprimo.map(item => ({
          //   ...item,
          //   descripcion: ''
          // }));


          },(error)=>{
              console.log(error)
          })

      });
  }

  reImprimirFactura(codigo:any){
    this.storages.get('companiasId').then((val) => {
        let consecutivo:number
        let deDonde: string
        let fecha: Date

        consecutivo = Number(codigo.consecutivo)
        deDonde = codigo.deDonde
        fecha = codigo.fechaVenta

    if (deDonde=='V'){
      this.servicioCaja.buscarVentasDiarias(consecutivo,val)
      .subscribe((data)=>{
        let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
        this.reemprimirReciboDia(response)
      },
      error=>{
        console.log(error)
      })
    }
    else
    {
      if (deDonde=='H'){
        this.servicio.buscarVentasDiariasHistorico(consecutivo,val,fecha)
        .subscribe((data)=>{
          let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
          this.reemprimirReciboDia(response)
        },
        error=>{
          console.log(error)
        })
      }
    }
  })
}


visualizarReciboEnPantalla(reciboCaja: any){
  this.storages.get('companiasId').then((val) => {
    let consecutivo:number
    let deDonde: string
    let fecha: Date

    consecutivo = Number(reciboCaja.consecutivo)
    deDonde = reciboCaja.deDonde
    fecha = reciboCaja.fechaVenta

if (deDonde=='V'){
  this.servicioCaja.buscarVentasDiarias(consecutivo,val)
  .subscribe((data)=>{
    this.utils.mostrarReciboDeCajaEnPantalla(consecutivo,data)
  },
  error=>{
    console.log(error)
  })
}
else
{
  if (deDonde=='H'){
    this.servicio.buscarVentasDiariasHistorico(consecutivo,val,fecha)
    .subscribe((data)=>{
      this.utils.mostrarReciboDeCajaEnPantalla(consecutivo,data)
    },
    error=>{
      console.log(error)
    })
  }
}
})

}


reemprimirReciboDia(elRecibo:any){
  let recibo = ''

      for (let index:any = 0; index < elRecibo.length; index++) {
        recibo += elRecibo[index]['reciboCaja'] + '\n'
      }

        this.servicioCaja.imprimirRecibo(recibo).subscribe(
            res => {

            },
            err => {

                    let alert = this.alertControllers.create({
                        title: '',
                        subTitle: recibo,
                        buttons: ['Cerrar']
                    });
                    alert.present();

                })
}


  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }


  async valoresCufe(item:any = undefined) {
    //let codigoQr = "1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834"
    let codigoQr = ''
     let responseCompania = await this.dian.devolverCompania()
    let companiasId = await localStorage.getItem('companiasId')
      let cufeResponse = await this.dian.buscarCufe(companiasId,item.consecutivo).toPromise()
      let cufeNuevo = JSON.parse(cufeResponse['_body'])
      if(cufeNuevo && cufeNuevo.data && cufeNuevo.data[0] && cufeNuevo.data[0][0]) {
        codigoQr = cufeNuevo.data[0] && cufeNuevo.data[0][0].cufe
        //this.imprimirGlobal(item.factura,codigoQr)
        this.imprimirFacturadiaCufe(item,codigoQr)
      } else {
        this.utils.mensajeMuestro('Factura electrónica',`Para la factura: ${item.consecutivo} no existe una factura electrónica asociada`,'warning')
      }

  }

  imprimirFacturadiaCufe(codigo:any,cufe:any=''){
    this.storages.get('companiasId').then((val) => {
      let factura:number
      factura = Number(codigo.consecutivo)

      this.servicioCaja.buscarVentasDiariasCufe(factura,val)
      .subscribe((data)=>{
        let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
        this.reemprimirReciboDiaCufe(response,cufe)
      },
      error=>{
        console.log(error)
      })
    })
  }

  async reemprimirReciboDiaCufe(mensaje,cufe:any='') {
    let recibo = ''

  for (let index:any = 0; index < mensaje.length; index++) {
    //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
    const textoRecibo = mensaje[index]['reciboCaja'];

    // Comandos ESC/POS para negrita y tamaño de fuente
    const negritaOn = '\x1b\x45\x01'; // Activar negrita
    const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
    const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
    const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
    const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

    if (textoRecibo.includes("TOTAL A PAGAR")) {
      recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
    } else {
      if(textoRecibo.includes("CAMBIO")) {
        recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
      } else {
        recibo += '   ' + textoRecibo + '\n';
      }
    }
  }

  this.servicioCaja.imprimirReciboCufe(recibo,cufe).subscribe(
    res => {

    },
    err => {
      this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

        })

 }


descargarExcel() {
  if(this.listaVentasReimprimo.length>0) {
    this.servicio.exportToExcel(this.listaVentasReimprimo, 'reimprimir-recibo-caja')
  }
}

cleanNumber(value: any): number {
  if (typeof value === 'string') {
    // Reemplazar comas por puntos y eliminar caracteres no numéricos excepto puntos y guiones
    value = value.replace(/\./g, '').replace(/,/g, '.').replace(/[^0-9.-]+/g, '');
  }
  return parseFloat(value);
}

  // Método para formatear el número con separadores de miles y dos decimales
  formatNumber(value: number): string {
    return value.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  cambiarFechaClick(event: any) {
    this.valorfechaInicial = event
  }
  cambiarFechaClickFinal(event: any) {
    this.valorFechaFinal = event
  }

  buscarRecibosCajaReImprimeCalendar(valorFechaInicial:any,valorFechaFinal:any){
    let fechaDesde = valorFechaInicial
    let fechaHasta = valorFechaFinal
    this.storages.get('companiasId').then((val) => {

      this.servicio.buscarListadoRecibosCajaReImprime(val,fechaDesde,fechaHasta)
          .subscribe((data)=>{
           let valor = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])

           if (Array.isArray(valor) && Array.isArray(valor[0])) {
            this.listaVentasReimprimo = valor[0].map(item => {
              item.valorVenta = this.cleanNumber(item.valorVenta);
              return item;
            });
          } else if (Array.isArray(valor)) {
            this.listaVentasReimprimo = valor.map(item => {
              item.valorVenta = this.cleanNumber(item.valorVenta);
              return item;
            });
          } else {
            this.listaVentasReimprimo = [];
          }


          },(error)=>{
              console.log(error)
          })

      });
  }
  onFocusFechaInicial() {
    this.isFocusedFechaInicial = true;
  }

  onBlurFechaInicial() {
    this.isFocusedFechaInicial = false;
    this.validateDatevalorfechaInicial();
  }
  validateDatevalorfechaInicial() {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(this.valorfechaInicial)) {
      alert('Por favor, ingresa una fecha válida en el formato YYYY-MM-DD');
      this.valorfechaInicial = '';
    }
  }


  onFocusFechaFinal() {
    this.isFocusedFechaInicial = true;
  }

  onBlurFechaFinal() {
    this.isFocusedFechaFinal = false;
    this.validateDatevalorfechaFinal();
  }
  validateDatevalorfechaFinal() {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(this.valorFechaFinal)) {
      alert('Por favor, ingresa una fecha válida en el formato YYYY-MM-DD');
      this.valorFechaFinal = '';
    }
  }

  async guardarDescripcion(item: any) {
    if (item.descripcion && item.descripcion.trim() !== '') {
      let companiasId = await localStorage.getItem('companiasId')
      this.servicio.gestionarClienteDescripcion(companiasId,item.clientesId,item.descripcion)
          .subscribe((data)=>{
           let valor = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
            this.utils.mensajeMuestro('Descripción cliente',`la descripción se guardo con exito`,'success')
          },(error)=>{
              console.log(error)
          })
    } else {
      console.log('No se puede guardar una descripción vacía');
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/informe-reimprimir-recibo-caja/informe-reimprimir-recibo-caja.ts